import React, { useEffect, useRef } from "react";

// Minimal donut/pie chart on canvas
// Props: labels: string[], values: number[], colors?: string[], donut?: boolean
const PieChart = ({ labels = [], values = [], colors, donut = true }) => {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const w = (canvas.width = canvas.clientWidth);
    const h = (canvas.height = canvas.clientHeight);
    ctx.clearRect(0, 0, w, h);
    const total = values.reduce((a, b) => a + (Number(b) || 0), 0);
    if (total <= 0) {
      ctx.fillStyle = "#9ca3af";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.font = "12px sans-serif";
      ctx.fillText("Keine Daten", w / 2, h / 2);
      return;
    }
    const cx = w / 2;
    const cy = h / 2;
    const r = Math.min(w, h) * 0.45;
    const palette = colors && colors.length ? colors : [
      "#2563eb", "#16a34a", "#f59e0b", "#ef4444", "#8b5cf6", "#10b981", "#f472b6", "#06b6d4", "#84cc16", "#f97316"
    ];
    let start = -Math.PI / 2;
    values.forEach((val, i) => {
      const frac = (Number(val) || 0) / total;
      const end = start + frac * Math.PI * 2;
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.fillStyle = palette[i % palette.length];
      ctx.arc(cx, cy, r, start, end);
      ctx.closePath();
      ctx.fill();
      start = end;
    });
    if (donut) {
      ctx.globalCompositeOperation = "destination-out";
      ctx.beginPath();
      ctx.arc(cx, cy, r * 0.62, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalCompositeOperation = "source-over";
      // Center total label
      ctx.fillStyle = "#374151";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.font = "bold 12px sans-serif";
      ctx.fillText(String(total), cx, cy);
    }
  }, [labels, values, colors, donut]);

  return (
    <div className="w-full h-40">
      <canvas ref={canvasRef} className="w-full h-full" />
    </div>
  );
};

export default PieChart;
